import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-format-indent-increase",
  templateUrl: "./med-icon-format-indent-increase.component.html",
})
export class MedIconFormatIndentIncreaseComponent extends SvgMixinComponent {}
